import type { ReactNode } from 'react';
import { TabBar } from './TabBar';
import { LiveSessionBar } from './LiveSessionBar';

export function MainLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <LiveSessionBar />
      <div className="app-shell">{children}</div>
      <TabBar />
    </>
  );
}
